import type { GridProps} from '@chakra-ui/react'
import { Grid, Image } from '@chakra-ui/react'
import { useEffect, useState } from 'react'

import { useWizzardHeader } from '../../context/WizzardHeaderContext'
import image from '../../images/apps/property.png'

export interface WizzardHeaderPropertyInfoProps extends GridProps {

}

export const WizzardHeaderPropertyInfo = (props: WizzardHeaderPropertyInfoProps) => {
  const { isScrolled } = useWizzardHeader()
  const [logoSize, setLogoSize] = useState(120)

  useEffect(() => {
    setLogoSize(isScrolled ? 90 : 120)
  }, [isScrolled])

  return (
    <Grid
      sx={{
        position: 'relative',
        w: { base: '100%', md: '250px' },
        gridTemplateColumns: {
          base: 'auto 1fr',
          md: '1fr',
        },
        mt: { md: isScrolled ? -6 : -8 },
        mb: { md: -4 },
        borderRadius: { base: 'md', md: 0 },
        overflow: {
          base: 'hidden',
          md: 'visible',
        },
        transition: 'all 200ms ease-in-out',
      }}
    >
      <Grid
        sx={{
          p: { base: 2, md: isScrolled ? 3 : 6 },
          justifyContent: 'center',
          bg: 'white',
          borderTopRadius: { md: 'md' },
          transition: 'all 200ms ease-in-out',
        }}
      >
        <Image
          src={image}
          sx={{
            maxWidth: {
              base: 12,
              md: `${logoSize}px`,
            },
            maxHeight: {
              // base: 12,
              // md: `${logoSize}px`,
            },
            transition: 'all 200ms ease-in-out',
          }}
        />
      </Grid>
    </Grid>
  )
}
